import React, {useState} from "react";

import {RaikoButtonPrimary, RaikoInputSubmitCode, RaikoLabel} from '@moeindal/base-raiko-panel-components'

import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {useLocation, useNavigate} from "react-router-dom";
import {RouteInfo} from "../../../route/RouteHelper";
import {FormControl} from "@mui/material";
import RaikoMaterialOutlinedPasswordInput
    from "../../../raikoComponents/raikoInputs/RaikoMaterialOutlinedPasswordInput";
import {css} from "@emotion/css";
import {LoginService} from "../../../connection-services/login/LoginService";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {Helmet} from "react-helmet";

const SignInRefreshPassword = () => {

    const {state} = useLocation()
    const navigate = useNavigate()

    const service = new LoginService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [submitCode, setSubmitCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(state && state.phoneNumber ? state.phoneNumber : "");
    const [username, setUsername] = useState("");
    const [newPassword, setNewPassword] = useState("")

    function goForEditPhoneNumber() {
        navigate(RouteInfo.SignInForgetPassword.globalUrl, {state: {phoneNumber}, replace: true})
    }


    function validateAndRefreshPassword() {
        if (checkConditions()) {
            loading.show()

            service.updateForgotPassword(
                username,
                newPassword,
                phoneNumber,
                submitCode
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                navigate(RouteInfo.SignInEnterPhoneNumber.globalUrl)
            }).catch(reason => {
                snackbar.showServerErrorMessage(reason, "خطا در بروزرسانی اطلاعات ورود")
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkConditions() {
        let message = ""
        let state = false
        if (username.length === 0) {
            message = "لطفا نام کاربری خود را به درستی وارد نمایید."
        } else if (newPassword.length < 8) {
            message = "رمز عبور حداقل باید شامل ۸ کاراکتر باشد."
        } else
            state = true

        snackbar.showWarningMessage(message)

        return state
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInRefreshPassword.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>بازیابی رمز عبور</span>
                </div>
                <form className={"signInContentContainer"}>
                    <RaikoLabel
                        text={"لطفا کد تایید و اطلاعات خواسته شده را وارد نمایید."}
                    />
                    <div className={"editInfoContainer"}>
                        <div className={"editPhoneNumber"}
                             onClick={goForEditPhoneNumber}>
                            <div className={"ic-edit"}></div>
                            <span>{phoneNumber}</span>
                        </div>

                    </div>

                    <RaikoInputSubmitCode
                        handleCheckCode={_ => {
                        }}
                        labelText={"کد تایید"}
                        value={submitCode}
                        getCodeValue={setSubmitCode}/>


                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedPasswordInput
                            labelText="رمز عبور جدید"
                            placeHolder="رمز عبور خود را وارد کنید"
                            spellCheck={false}
                            value={newPassword}
                            onChange={e => {
                                setNewPassword(e.target.value)
                            }}

                            onKeyUp={e => {

                                if (e.key === 'Enter') {
                                    validateAndRefreshPassword()
                                }
                            }}

                        />
                    </FormControl>

                    <RaikoButtonPrimary
                        label={"تایید"}
                        className={css`width: 100%;
                          margin-top: .25rem !important;`}
                        onClick={validateAndRefreshPassword}/>

                </form>
            </div>
        </>
    )


}

export default SignInRefreshPassword;